const createType = (perfix: string) => {
  return {
    REQUEST: perfix + '_REQUEST',
    SUCCESS: perfix + '_SUCCESS',
    FAILED: perfix + '_FAILED'
  };
};

// 获取看板目录
export const GET_BOARD_MENU = createType('GET_BOARD_MENU');
export const GET_BOARD_ACCESS_USER = createType('GET_BOARD_ACCESS_USER');
export const SET_BOARD_ACCESS_USER = createType('SET_BOARD_ACCESS_USER');
export const SET_BOARD_ADMIN_USER = createType('SET_BOARD_ADMIN_USER');
export const GET_ProductDoc_list = createType('GET_ProductDoc_list');
export const GET_ProductDoc_ById = createType('GET_ProductDoc_ById');
export const GET_ProductEvn_list = createType('GET_ProductEvn_list');
export const GET_Business_Doc_Types = createType('GET_Business_Doc_Types');
export const GET_Business_Git_Branchs = createType('GET_Business_Git_Branchs');
export const SET_FORM_DATA = createType('SET_FORM_DATA');
export const HAS_BOARD_HEAD_ACCESS = createType('HAS_BOARD_HEAD_ACCESS');
export const ADMIN_USERS = createType('ADMIN_USERS');
